import * as z from "zod";

export const generateClaimInvoice = {
  name: "generateClaimInvoice" as const,
  input: z.object({ claimIds: z.array(z.string()).min(1) }),
  output: z.object({
    success: z.boolean(),
    invoiceUrls: z.record(z.string(), z.string().nullish()),
  }),
};
